package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
internal data class UpdateEmailV2ClientRequestInfo(val email: String, val messageToken: String?, val reCaptchaToken: String?)
